import React from "react";
import axios from "axios";
import './UsersAccount.css';
import { conn } from "../../Utilt/conn";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Loader from "../Loader/Loader";
import { FiEdit2 } from 'react-icons/fi'
import {MenuItem, Stack, Typography,} from '@mui/material';

import BasicMenu from '../ExistingAccount/menu/menu';
import ChangePin from '../ExistingAccount/changePin';
import ConfirmAdminPin from "../ExistingAccount/changePin/confirmPin";
import ProgressLoaderPin from "../ExistingAccount/changePin/loader";
import SuccessPin from "../ExistingAccount/changePin/success";

import ChangePassword from "../ExistingAccount/changePassword";
import ConfirmAdminPassword from "../ExistingAccount/changePassword/confirmPassword";
import ProgressLoaderPassword from "../ExistingAccount/changePassword/loader";
import SuccessPassword from "../ExistingAccount/changePassword/success";
import Layout from "../../ReuseComponent/Layout/Layout";

import LimitModal from "./Widget/LimitModal";
import RestrictModal from "./Widget/RestrictModal";
import avatarImage from '../../Assets/avatar-image.png'



export function UsersAccount() {


    const token = window.localStorage.getItem("token");
    const refreshtoken = window.localStorage.getItem("refreshtoken");

    const auth = JSON.parse(window.localStorage.getItem("auth"));

    const navigate = useNavigate();

    const location = useLocation();



    const [openD, setOpen] = useState(false);

    useEffect(() => {
        // { (token === "" || token === null || location.state === null) && navigate("/welcome") };
        UsersAccountData();
    }, []);




    const handleCloseD = () => {
        setOpen(false);
    };


    const config = {
        headers: {
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': '*',
            'token': token,
            'refreshtoken': refreshtoken
        }
    };

    const [isloading, loading] = useState(true);
    const [data, setData] = useState([]);

    const UsersAccountData = async () => {
        await axios.post(conn + "/admin/customer_accounts"
            , {
                "user_id": location.state.id,
                "page": 1,
                "limit": 100
            },
            config
        ).then((value) => {
            setData((value.data.data));
            loading(false);
        }).catch((error) => {

            console.log(error);
            loading(false);
            if (error.response.status === 401) navigate('/login')
        });
    }


    const UserTierUpgrade = async (account_id, top_tier, admin_id) => {

        setOpen(true);

        await axios.post(conn + "/admin/account/upgrade", {
            "account_id": account_id,
            "to_tier": top_tier,
            "admin_id": admin_id
        }, config).then((value) => {
            console.log(value.data)
            setOpen(false);
            setData([...data].map((val) =>
            val.id === account_id ? { ...val, account_tier: top_tier} : val

        ))
        }).catch((error) => {
            setOpen(false);
        });

    }

     // CHANGE PIN AND PASSWORD, MENU AND MODAL
     const [openMenu, setOpenMenu] = React.useState(null);
     const handleOpenMenu = (event) => {
         setOpenMenu(event.currentTarget);
       };
 
 
     // Change Pin management
     const [openChangePin, setOpenChangePin] = useState(false)
     const [openConfirmPin, setOpenConfirmPin] = useState(false)
     const [openLoaderPin, setOpenLoaderPin] = useState(false)
     const [openSuccessPin, setOpenSuccessPin] = useState(false)
     const [adminNewPin, setAdminNewPin] = useState({})
     const [progressAction, setProgressAction] = useState('pin')
 
     const handleOpenChangePin = () => {
         setOpenChangePin(true)
     }
   
     const handleCloseChangePin = () => {
         setOpenChangePin(false)
         setOpenMenu(false)
     }
     const handleSubmitChangePin = (pinData) => {
         setAdminNewPin(pinData)
         setOpenChangePin(false)
        //  setOpenConfirmPin(true)
         setProgressAction('pin')
         setOpenLoaderPin(true)
     }
 
     const handleCloseConfirmPin = () => {
         setOpenConfirmPin(false)
     }
     const handleSubmitConfirm = () =>{
         setOpenConfirmPin(false)
         setOpenLoaderPin(true)
     }
   
     const handleCloseLoader = () => {
         setOpenLoaderPin(false)
         setOpenSuccessPin(true)
     }
 
     const handleCloseSuccessPin = () => {
         setOpenSuccessPin(false)
     }
 
 
     // Change Password management
    const [openChangePassword, setOpenChangePassword] = useState(false)
    const [openConfirmPassword, setOpenConfirmPassword] = useState(false)
    const [openLoaderPassword, setOpenLoaderPassword] = useState(false)
    const [openSuccessPassword, setOpenSuccessPassword] = useState(false)
    const [adminNewPassword, setAdminNewPassword] = useState({})


    const handleOpenChangePassword = () => {
        setOpenChangePassword(true)
    }
  
    const handleCloseChangePassword = () => {
        setOpenChangePassword(false)
    }
    const handleSubmitChangePassword = (passwordData) => {
        setAdminNewPassword(passwordData)
        setOpenChangePassword(false)
        setOpenConfirmPassword(true)
    }

    const handleCloseConfirmPassword = () => {
        setOpenConfirmPassword(false)
    }
    const handleSubmitConfirmPassword = () =>{
        setOpenConfirmPassword(false)
        setOpenLoaderPassword(true)
    }
  
    const handleCloseLoaderPassword = () => {
        setOpenLoaderPassword(false)
        setOpenSuccessPassword(true)
    }

    const handleCloseSuccessPassword = () => {
        setOpenSuccessPassword(false)
    }

    // LIMIT management
    const [openLimitModal, setOpenLimitModal] = useState(false)
    const [accountData, setAccountData] = useState(null)
    const [limitData, setLimitData] = useState(null)
    
    const handleCloseLimitModal = () => {
        setOpenLimitModal(false)
        setOpenMenu(false)
    }
    const handleOpenLimitModal = () => {
        setOpenLimitModal(true)
    }

    const handleSubmitLimitModal = (limitData) => {
        handleCloseLimitModal()
        setLimitData(limitData)
        setOpenConfirmPin(true)
        setProgressAction('limit')

    }


     // RESTRICT management
     const [openRestrictModal, setOpenRestrictModal] = useState(false)
     const [restrictData, setRestrictData] = useState('')
     
     const handleCloseRestrictModal = () => {
         setOpenRestrictModal(false)
         setOpenMenu(false)
     }
     const handleOpenRestrictModal = () => {
         setOpenRestrictModal(true)
     }
 
     const handleSubmitRetrictModal = (restrictData) => {
        console.log(restrictData)
         handleCloseRestrictModal()
         setRestrictData(restrictData)
         setOpenConfirmPin(true)
         setProgressAction('restrict')
 
     }



    return (
        <>
             <BasicMenu openMenu={openMenu} setOpenMenu={setOpenMenu}>
                <MenuItem onClick={handleOpenLimitModal}>Account Transfer Limit</MenuItem>
                <MenuItem onClick={handleOpenChangePin}>Change User’s PIN</MenuItem>
                <MenuItem sx={{color:'red'}} onClick={handleOpenRestrictModal}>Restrict Account</MenuItem>
             </BasicMenu>

            {/* CHANGE PIN MANAGEMENT */}
            {openChangePin && <ChangePin openChangePin={openChangePin} handleCloseChangePin={handleCloseChangePin} submitChangePin={(pinData)=>handleSubmitChangePin(pinData)} data={data}/> }

            <ConfirmAdminPin openConfirm={openConfirmPin} handleCloseConfirm={handleCloseConfirmPin} handleSubmitConfirm={handleSubmitConfirm}/>
            {openLoaderPin && <ProgressLoaderPin openLoader={openLoaderPin} setOpenLoaderPin={setOpenLoaderPin} handleCloseLoader={handleCloseLoader} data={adminNewPin} limitData={limitData} restrictData={restrictData} action={progressAction} _user={data}/> }
            {openSuccessPin && <SuccessPin openSuccesPin={openSuccessPin} handleCloseSuccessPin={handleCloseSuccessPin} _user={data} action={progressAction} limitData={limitData} pin={adminNewPin}/> }
            
            
            {/* CHANGE PASSWORD MANAGEMENT */}
            {openChangePassword && <ChangePassword openChangePassword={openChangePassword} handleCloseChangePassword={handleCloseChangePassword} submitChangePassword={(passwordData)=>handleSubmitChangePassword(passwordData)} data={data}/> }
            <ConfirmAdminPassword openConfirm={openConfirmPassword} handleCloseConfirm={handleCloseConfirmPassword} handleSubmitConfirm={handleSubmitConfirmPassword}/>
            {openLoaderPassword && <ProgressLoaderPassword openLoader={openLoaderPassword} handleCloseLoader={handleCloseLoaderPassword} data={adminNewPassword} _user={data}/> }
            {openSuccessPassword && <SuccessPassword openSuccesPassword={openSuccessPassword} handleCloseSuccessPassword={handleCloseSuccessPassword} _user={data} password={adminNewPassword}/> }
           
           {/* LIMIT MANAGEMENT */}
           {openLimitModal && <LimitModal openLimitModal={openLimitModal} handleCloseLimitModal={handleCloseLimitModal} data={accountData} handleSubmit={(data)=>handleSubmitLimitModal(data)}/>}
            
            {/* RESTRICT ACCOUNT MANGEMENT */}
            {openRestrictModal && <RestrictModal openRestrictModal={openRestrictModal} handleRestrictModal={handleCloseRestrictModal} data={accountData} handleSubmit={(data)=>handleSubmitRetrictModal(data)}/>}

            <Layout label="Customer Accounts">
                
                <section>
                    <div className="in">
                       
                        <Stack direction={'row'} spacing={2} my={'30px'} py={'20px'} sx={{width: '100%', overflowX:'auto'}}>

                            <WrapperContainer style={{flexDirection: 'row', gap: '10px'}} >
                                <img src={location.state.image ?? avatarImage} alt="" style={{width:'100px', height: '100px', borderRadius:'50px'}}/>
                               
                               <Stack direction={'column'} alignItems={'center'}>
                                <Typography sx={{color:'#252424', fontSize:'20px'}}>{location.state.user}</Typography>
                                <Fade duration={1000}><Typography sx={{color:'#66A681', fontSize:'30px'}}>{data.length}</Typography></Fade>
                                <Typography sx={{color:'#565555', fontSize:'14px'}} >Total Number of Accounts</Typography>

                               </Stack>
                            </WrapperContainer>
                            {(data.map((val, index) => 
                                <WrapperContainer style={{border:'1px dashed', borderSpacing:'100px'}}>
                                    <Typography sx={{color:'#565555', fontSize:'14px'}}>Account {index + 1}</Typography>
                                    <Fade duration={1000}><Typography sx={{color:'#252424', fontSize:'18px'}}>{val.nuban}</Typography></Fade>
                                    <Fade duration={1000}><Typography sx={{color:'#66A681', fontSize:'30px', mt:'10px'}}>{val.balance ?? 0}</Typography></Fade>
                                    <Typography sx={{color:'#565555', fontSize:'14px'}}>Account Balance</Typography>
                                </WrapperContainer>
                            ))}


                          
                        </Stack>


                        <div className="account_list">

                            <p>Accounts</p>

                            { (!isloading) ?  <div className="table">

                                <table cellSpacing="0">
                                    <thead>
                                        <td>Name</td>
                                        <td>Nuban</td>
                                        <td>Date Of Creation</td>
                                        <td>Tier</td>
                                        <td>Transactions</td>
                                        <td>Secuirity</td>

                                    </thead>

                                    {
                                    data.map((user, key) =>
                                            <tr key={key}>
                                                <td><Fade duration={1000}>{user.account_name}</Fade></td>
                                                <td><Fade duration={1000}><span className="numba">{user.nuban}</span></Fade></td>
                                                <td>
                                                <Fade duration={1000}><span className="numba">{user.created_at.substring(0, 10)}</span></Fade>
                                                </td>
                                                
                                                <td>
                                                    <span className="select-cont"><select value={user.account_tier} onChange={(e) => UserTierUpgrade(user.id, e.target.value, auth.id)}>
                                                        <option value="1">Tier 1</option>
                                                        <option value="2">Tier 2</option>
                                                        <option value="3">Tier 3</option>
                                                    </select></span>
                                                </td>


                                                <td>
                                                <Fade duration={1000}><span onClick={()=>navigate('/transactions', {state:{id:location.state.id, nuban:user.nuban}})} style={{cursor:"pointer", fontSize:"14px", color:"green"}}>See Transactions</span></Fade>
                                                </td>
                                                <td>
                                                    <FiEdit2 className="edit-icon" onClick={(e)=>{handleOpenMenu(e); setAccountData(user)}}/>
                                                </td>
                                            </tr>
                                        )}

                                </table>

                            </div>: <center><Loader /></center> }

                        </div>

                    </div>

                </section>


                <Dialog
                    open={openD}
                    onClose={handleCloseD}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogContent>
                        <center>
                            <div style={{ width: "200px", padding: "30px" }}>

                                <p className="dialog-text" >Okay, We're upgrading the Account Tier now</p>
                                <br></br>

                                <div class="sk-bounce">
                                    <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                    <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                </div>

                            </div>
                        </center>
                    </DialogContent>

                </Dialog>

            </Layout>
        </>

    );


}


const WrapperContainer = ({children, style}) => {
    return(
        <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{
            border: '1px solid #E4E4E4',
            minWidth: '356px',
            height: '128px',
            borderRadius: '10px',
            padding: '10px',
            ...style
            }}>
           {children}
        </Stack>
    )
}